import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import {
  AlertInlineComponent,
  AUTH_MAIN_ROUTE,
  AUTH_ROUTES,
  MaintenanceModeComponent,
  NavbarComponent,
  SiteRedirectNoticeComponent,
  Toast,
  ToasterService,
} from '@kuiper/ibusiness-core';
import { filter, map, startWith } from 'rxjs';

@Component({
  imports: [
    RouterOutlet,
    AlertInlineComponent,
    SiteRedirectNoticeComponent,
    MaintenanceModeComponent,
    NavbarComponent,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly toastService = inject(ToasterService);
  private readonly router = inject(Router);

  showToast = signal<boolean>(false);
  toastData = signal<Toast>({
    alertData: {},
    hasCloseIcon: true,
    hasIcon: false,
  });

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(event => event.urlAfterRedirects),
      startWith(this.router.url)
    ),
    { initialValue: this.router.url }
  );

  readonly showAppNavbar = computed(() => {
    const url = this.currentUrl();
    return (
      url.startsWith(`/${AUTH_MAIN_ROUTE}`) ||
      url.startsWith(`/${AUTH_ROUTES.RESET_PASSWORD}`)
    );
  });

  constructor() {
    effect(() => {
      this.toastData.set(this.toastService.toasterData());
      this.showToast.set(this.toastService.showToast());
    });
  }

  onCloseToast($event: boolean) {
    this.toastService.showToast.set($event);
    this.toastService.resetInterval();
  }
}
